import { render, staticRenderFns } from "./sendDetail.vue?vue&type=template&id=5f2cf03a&scoped=true&"
import script from "./sendDetail.vue?vue&type=script&lang=js&"
export * from "./sendDetail.vue?vue&type=script&lang=js&"
import style0 from "./sendDetail.vue?vue&type=style&index=0&id=5f2cf03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2cf03a",
  null
  
)

component.options.__file = "sendDetail.vue"
export default component.exports